module.exports = __webpack_public_path__ + "static/media/arabidopsis_thaliana.9e029162.svg";